import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { FolderSpecial, HideSource } from '@mui/icons-material'
import { Button, ButtonGroup, FormControl } from '@mui/material'

import { GRTooltip } from '../../../../../components/GRTooltip/GRTooltip'
import { LiveEventGroupBy } from '../LiveEventsList'

type LiveEventGroupByToggleProps = {
  groupBy: LiveEventGroupBy
  hideDiscontinuedBlueprints: boolean
  onGroupByChange: () => void
  onHideDiscontinuedBlueprintsChange: () => void
}

/** Toggle buttons for grouping live events by blueprint/type and hiding discontinued blueprints */
export const LiveEventGroupByToggle: FC<LiveEventGroupByToggleProps> = ({
  groupBy,
  hideDiscontinuedBlueprints,
  onGroupByChange,
  onHideDiscontinuedBlueprintsChange,
}) => {
  const { t } = useTranslation()
  const groupByLabel = t(groupBy !== LiveEventGroupBy.Blueprint ? 'implementations:group_by_blueprint' : 'implementations:group_by_type')
  const hideDiscontinuedLabel = t(hideDiscontinuedBlueprints ? 'implementations:show_discontinued_blueprints' : 'implementations:hide_discontinued_blueprints')

  return (
    <FormControl size="small" variant="outlined">
      <ButtonGroup>
        <GRTooltip content={groupByLabel}>
          <Button onClick={onGroupByChange} variant={groupBy === LiveEventGroupBy.Blueprint ? 'contained' : 'outlined'} aria-label={groupByLabel}>
            <FolderSpecial />
          </Button>
        </GRTooltip>

        <GRTooltip content={hideDiscontinuedLabel}>
          <Button
            onClick={onHideDiscontinuedBlueprintsChange}
            aria-label={hideDiscontinuedLabel}
            disabled={groupBy !== LiveEventGroupBy.Blueprint}
            variant={hideDiscontinuedBlueprints ? 'contained' : 'outlined'}
          >
            <HideSource />
          </Button>
        </GRTooltip>
      </ButtonGroup>
    </FormControl>
  )
}
